import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import styles from "./HelpSupportStyle.module.css";
import TutorialVideo from "./TutorialVideo";
import Faq from "./Faq";
import videIcon from "../../Assets/Images/icon-video-tutorial.svg";
import faqIcon from "../../Assets/Images/icon-faq.svg";
import { deviceCheck } from "../../Values/utils";
import {setCurrentRoute } from "../../Redux/actions";
import { useLocation } from "react-router-dom";
import {  useDispatch } from "react-redux";

type props = {};

const HelpSupport: FunctionComponent<props> = ({ }) => {
    const [helpTab, setHelpTab] = useState("Video");
    const [cRoute,setCRoute]=useState("") 
         const location: any = useLocation();
             const dispatcher = useDispatch();                    
                            useEffect(() => {
                              dispatcher(setCurrentRoute(location.pathname))
                              setCRoute(location.pathname)
                            }, [location]);

    const handleTabClick = (tab: string) => {
        setHelpTab(tab);
    }

    const handleOpenHelpPage = () => {
        window.open("https://www.magicbricks.com/help/", "_blank");
    }

    return (
        <div className={styles.HelpSupport}>
            <div className={styles.HelpSupportHeadWrap}>
                <div className={styles.HelpSupportHeading}>Help and Support</div>
                {/* <div className={styles.HelpSupportInfo}>
                    <div className={styles.HelpSupportInfoItem}>
                        <div className={styles.HelpSupportInfoTitle}>Email Us on</div>
                        <div className={styles.HelpSupportInfoValue}>support@magicbricks.com</div>
                    </div>
                    <div className={styles.HelpSupportInfoItem}>
                        <div className={styles.HelpSupportInfoTitle}>Call us on</div>
                        <div className={styles.HelpSupportInfoValue}>0120-6866600</div>
                    </div>
                </div> */}

                <div className={styles.HelpSupportHeadBottom}>
                    <div className={styles.HelpSupportHeadTitle}>In case of any technical issues or concerns, use our chatbot for instant assistance.</div>
                    <div className={styles.HelpSupportHeadCtaWrap}>
                        {/* <div className={styles.HelpSupportHeadCta}>Check Status</div> */}
                        <div className={`${styles.HelpSupportHeadCta} ${styles.Filled}`} onClick={handleOpenHelpPage}>Need Help? Chat Now</div>
                    </div>
                </div>
            </div>


            <div className={styles.HelpSupportWrap}>

                <div className={styles.HelpSupportTabWrap}>
                    <div className={`${styles.HelpSupportTabItem} ${helpTab === 'Video' ? styles.Active : ''}`} onClick={() => handleTabClick("Video")}>
                        <div className={styles.HelpSupportTabItemIcon}><img alt="" src={videIcon} /></div>
                        <div className={styles.HelpSupportTabItemContent}>
                            <div className={styles.HelpSupportTabTitle}>
                                Tutorial Videos
                            </div>
                            { !deviceCheck() && <div className={styles.HelpSupportTabText}>
                                Illustrative tutorial videos for different  tasks in read pro
                            </div>}
                        </div>
                    </div>

                    <div className={`${styles.HelpSupportTabItem} ${helpTab === 'Faq' ? styles.Active : ''}`} onClick={() => handleTabClick("Faq")}>
                        <div className={styles.HelpSupportTabItemIcon}><img alt="" src={faqIcon} /></div>
                        <div className={styles.HelpSupportTabItemContent}>
                            <div className={styles.HelpSupportTabTitle}>
                                { deviceCheck() ? "FAQ" :  "Frequently Asked Questions"}
                            </div>
                            { !deviceCheck() && <div className={styles.HelpSupportTabText}>
                                Answers to queries on functionalities in different user journeys
                            </div>}
                        </div>
                    </div>
                </div>

                {helpTab === "Video" ?
                    <TutorialVideo />
                    :
                    <Faq />
                }
            </div>
        </div>
    );
};

export default HelpSupport;